import { message } from "antd";
import { NewPassword } from "components/Auth/ForgetPassword/NewPassword";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const NewPasswordContainer: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as { email: string }

    useEffect(() => {
        if ((!state || !state.email)) {
            message.error("You are not authorized to access this page yet.");
            navigate("/forgot-password");
            return;
        }
    }, [navigate, state]);

    return (
        <NewPassword email={state?.email} />
    );
};
